import React from "react";
import styled from "styled-components";
import { Group } from "@domain/group/group";
import { useIsLearner } from "@domain/currentProfile/hooks";
import { useWorkspaces } from "@domain/group/workspace/hooks";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { CreateWorkspaceThumbnail } from "./createWorkspaceThumbnail";
import { WorkspaceThumbnail } from "./workspaceThumbnail";

interface WorkspaceListProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}
export const WorkspaceList: React.FC<WorkspaceListProps> = ({ shareroom, ...htmlProps }) => {
	const { result: workspaces, loading, fetchMore } = useWorkspaces(shareroom.id);
	const isLearner = useIsLearner();
	return (
		<Container {...htmlProps}>
			<InfiniteScroll loading={loading} onEndReached={fetchMore}>
				{workspaces.map((workspace) => (
					<WorkspaceThumbnail key={workspace.id} shareroom={shareroom} workspace={workspace} />
				))}
				{shareroom.userRole === "ADMINISTRATOR" && !isLearner && <CreateWorkspaceThumbnail shareroom={shareroom} />}
			</InfiniteScroll>
		</Container>
	);
};

const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, 330px);
	grid-template-rows: repeat(auto-fill, 270px);
	grid-auto-rows: 270px;
	grid-gap: 25px;
`;
